import type { GetRecommendationsResponse, Product } from '@kimuno/api-sdk';

import type { AsyncAction } from './common.actionTypes';

export enum FETCH_DASHBOARD_RECOMMENDATIONS {
	START = 'FETCH_DASHBOARD_RECOMMENDATIONS_START',
	SUCCESS = 'FETCH_DASHBOARD_RECOMMENDATIONS_SUCCESS',
	ERROR = 'FETCH_DASHBOARD_RECOMMENDATIONS_ERROR',
}

export type FetchDashboardRecommendationsAction = AsyncAction<
	typeof FETCH_DASHBOARD_RECOMMENDATIONS.START,
	typeof FETCH_DASHBOARD_RECOMMENDATIONS.SUCCESS,
	typeof FETCH_DASHBOARD_RECOMMENDATIONS.ERROR,
	{ recommendations: GetRecommendationsResponse; products: Product[] }
>;
